import { Injectable } from '@angular/core';
import { ServicingBaseClass } from '@common/components';
import {
  GetReceiptStore,
  resetGetReceipt,
  selectGetReceiptIsFailureStatus,
  selectGetReceiptState,
  setGetReceiptFromApi,
} from '@common/store/get-receipt';
import { CommonLibService } from '@lib/services';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, withLatestFrom } from 'rxjs/operators';
import { GetReceiptRequest, GetReceiptResponse } from 'src/sdk-servicing';
import { DefaultService as Api } from 'src/sdk-servicing/api/default.service';

/**
 * 【領収書PDF取得API】操作のためのサービス
 */
@Injectable()
export class GetReceiptStoreService extends ServicingBaseClass {
  private result$!: Observable<GetReceiptResponse | null>;
  private failure$!: Observable<boolean>;

  public get res$() {
    return this.result$;
  }

  constructor(private store: Store<GetReceiptStore>, private api: Api, private common: CommonLibService) {
    super();
    this.result$ = this.store.pipe(
      select(selectGetReceiptState),
      map((state) => state.model)
    );
    this.failure$ = this.store.pipe(
      select(selectGetReceiptIsFailureStatus),
      filter((isFailure) => isFailure)
    );
  }

  setupHandler(responseHandler: (response: GetReceiptResponse) => void, errorHandler: (apiErrorCode?: string) => void) {
    this.subscribeService(this.result$, (result) => {
      if (result) {
        responseHandler(result);
      }
    });
    this.subscribeService(
      this.failure$.pipe(
        withLatestFrom(this.common.apiErrorResponseService.getApiErrorResponse$(), (_, state) => state)
      ),
      (model) => {
        const errors = model?.errors;
        const apiErrorCode = errors && errors.length ? errors[0].code : undefined;

        errorHandler(apiErrorCode);
      }
    );
  }

  callApi(req: GetReceiptRequest) {
    const call = this.api.ordersGetReceiptPost(req);
    this.store.dispatch(setGetReceiptFromApi({ call }));
  }
  /**
   * ストアを空にします。
   */
  clearStore(): void {
    this.store.dispatch(resetGetReceipt());
  }

  override destroy(): void {}
}
